import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { mainContentStyles } from './mainContentStyles';
import { VestingCard } from '../VestingCard/VestingCard';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useWallet } from '../../hooks/useWallet';
import useMediaQuery from '@mui/material/useMediaQuery';
import { MyTokensMobile } from '../MyTokensMobile/ MyTokensMobile';
import {
  VESTING_1_ADDRESS,
  VESTING_2_ADDRESS,
  VESTING_3_ADDRESS
} from '../../services/endpoints';
import { ExplanationAlert } from '../ExplanationAlert/ExplanationAlert';
import { getVestingInfo } from '../../store/vestingInfo/actions/getVestingInfo';
import { selectVestingInfoLoading } from '../../store/vestingInfo/vestingInfoSlice';
import { LoadingType } from '../../models/LoadingType';
import { OnRamper } from '../OnRamper/OnRamper';
import { ModalBuyTokens } from '../ModalBuyTokens/ModalBuyTokens';
import { cleanVestingInfo } from '../../store/vestingInfo/actions/cleanVestingInfo';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { CircularProgress } from '@mui/material';
import i18next from 'i18next';

export const MainContent = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { userAddress } = useWallet();
  const isDark = theme.palette.mode === 'dark';
  const classes = mainContentStyles(theme, isDark);
  const vesting1Address = VESTING_1_ADDRESS;
  const vesting2Address = VESTING_2_ADDRESS;
  const vesting3Address = VESTING_3_ADDRESS;
  const isDownMd = useMediaQuery(theme.breakpoints.down('md'));
  const vestingContractAddresses = [
    vesting1Address,
    vesting2Address,
    vesting3Address
  ];
  const loading = useSelector(selectVestingInfoLoading);
  const { isWalletConnected } = useWallet();
  const isLoading = loading !== LoadingType.Succeeded && isWalletConnected;
  const vestingCardsTitles = [
    i18next.t('vesting.card_data.round.title', { round: 1 }),
    i18next.t('vesting.card_data.round.title', { round: 2 }),
    i18next.t('vesting.card_data.round.title_referrals')
  ];
  useEffect(() => {
    if (userAddress) {
      dispatch(getVestingInfo({ vestingContractAddresses }));
      return;
    }
    dispatch(cleanVestingInfo());
  }, [userAddress]);

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <Dialog
        open={isLoading}
        sx={classes.circularProgress}
        disableScrollLock={true}
      >
        <DialogContent>
          <CircularProgress />
        </DialogContent>
      </Dialog>

      <Box>
        <Grid container>
          {isDownMd && (
            <>
              <Grid item xs={12}>
                <MyTokensMobile />
              </Grid>
              <Grid item xs={12} onClick={handleOpen} sx={classes.onRamper}>
                <OnRamper handleClick={handleOpen} />
              </Grid>
            </>
          )}
          <Grid
            item
            container
            spacing={{ xs: 1, md: 2 }}
            wrap='nowrap'
            direction={{ xs: 'column', md: 'row' }}
            sx={classes.cardContainer}
          >
            <>
              {vestingContractAddresses.map(
                (vestingAddress: string, index: number) => (
                  <Grid
                    item
                    xs={12}
                    key={vestingAddress}
                    sx={{ display: 'flex' }}
                  >
                    <VestingCard
                      vestingAddress={vestingAddress}
                      title={vestingCardsTitles[index]}
                    />
                  </Grid>
                )
              )}
            </>
          </Grid>
        </Grid>
      </Box>
      <ExplanationAlert />
      <ModalBuyTokens open={open} onClose={handleClose} />
    </>
  );
};
